import { AEMFeatureFlags } from '@com-delta-idp/mnx-skymiles-shared';
import { Features } from '../../models/features.interfaces';

export const AemFeatureFlagsMocks: AEMFeatureFlags<Features> = {
  flags: {
    medallionBanner: true,
    menu: true
  }
};
